import { useContext } from 'react';
import { Link, Typography } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppProvider';

export function Links(props: any) {
	const { config, entityType, t } = useContext(AppContext);
	const { className, links } = props;
	return (
		<>
			{Object.keys(links).map(i => (
				<Typography TagName="p" key={i}>
					<Link className={className} href={href(links[i], config.APP_ENV)} label={t(`${i}_${entityType}`, 'finish')} />
				</Typography>
			))}
		</>
	);
}

function href(x: string | Function, env: string): string {
	return typeof x === 'function' ? x(env) : x;
}
